import React from 'react';
import { HeroVariant52 } from '../components/HeroVariant52';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage52() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1702">
      <Navigation data-id="element-1703" />
      <main data-id="element-1704">
        <HeroVariant52 data-id="element-1705" />
        <WhyUs data-id="element-1706" />
        <Services data-id="element-1707" />
        <FAQ data-id="element-1708" />
        <Testimonials data-id="element-1709" />
        <Consultation data-id="element-1710" />
      </main>
      <Footer data-id="element-1711" />
      <CookieBanner data-id="element-1712" />
      <FloatingContact data-id="element-1713" />
    </div>;
}